export const BUILD_BUTTON_TEXT = {
  BUILDING: "Building...",
  BUILD: "Build"
};

export const BUILD_TOOLTIP = {
  NO_CHANGES: "No changes were submitted",
  MANDATORY_MISSING: "Resolve configuration \n errors to enable Build",
  IN_PROGRESS: "Build is in progress"
};
